import { useFormikContext } from 'formik';
import { InputUI } from '../Interface';
import useAME from '../../hooks/useAME';
import AMESelect from '../AME/AMESelect';

export default function ItemAMETab({ disabled }) {
  const { values, setFieldValue } = useFormikContext();
  const codes = useAME(true);
  const selected = codes.find((row) => row.code === values.ameCode);
  return (
    <div className="grid gap-4 p-4">
      <AMESelect codes={codes} value={values.ameCode} disabled={disabled}
        onChange={(_event, option) => setFieldValue('ameCode', option?.value ?? null)} />
      <InputUI label="ÁME szövege" value={selected?.description ?? ''} disabled fullWidth
        multiline minRows={6} variant="standard" InputLabelProps={{ shrink: true }} />
    </div>
  );
}
